<app-loading [options]="loadingOpts$ | async" *ngIf="(loadingOpts$ | async)?.isLoading" />
<app-breadcrumb-header
  [includeBanner]="(alertIsActive$ | async) && !(isCreatingAlert$ | async)"
  [headerTitle]="pageTitle$ | async"
  [breadcrumbs]="breadcrumbs$ | async">
  <div
    class="active-alert"
    *ngIf="(alertIsActive$ | async) && !(isEditingAlert$ | async) && !(isCreatingAlert$ | async)">
    <img [src]="'assets/icons/alerts/AlertActive.svg'" />
    <span class="active-alert-text" i18n>The alert is active</span>
  </div>
  <div
    class="edit-active-alert"
    *ngIf="(alertIsActive$ | async) && (isEditingAlert$ | async) && !(isCreatingAlert$ | async)">
    <img [src]="'assets/icons/alerts/EditActiveAlert.svg'" />
    <span class="edit-active-alert-text" i18n
      >You are editing an active alert. Any changes you publish will be visible to users who are targeted by this
      alert.</span
    >
  </div>
</app-breadcrumb-header>
<div class="banner-spacer" *ngIf="(alertIsActive$ | async) && !(isCreatingAlert$ | async)"></div>
<div>
  <div
    class="banner-preview-container"
    *ngIf="showBannerAlertPreview$ | async"
    [style.margin-bottom.rem]="0"
    [style.margin-top.rem]="-1">
    <app-banner-alert
      *ngIf="!(previewLoading$ | async)"
      [style.margin-bottom.rem]="2"
      [alert]="alertPreview$ | async" />
    <lib-loading-shimmer
      *ngIf="previewLoading$ | async"
      [width]="'100%'"
      [height]="'2.815rem'"
      [style.margin-bottom.rem]="2" />
  </div>
  <div class="card-form-content-container" [style.margin-top.rem]="0">
    <div class="card-form-container">
      <div class="d-flex justify-content-end gap-3">
        <div *ngIf="canDeleteAlert$ | async" class="edit-button-container">
          <lib-button-outlined (buttonClicked)="openDeleteModal()">
            <img [src]="'assets/icons/primary/Garbage.svg'" />
            <span i18n>Delete</span>
          </lib-button-outlined>
        </div>
        <div
          *ngIf="
            !(isPastAlert$ | async) &&
            (canEditAlertDetails$ | async) &&
            !(isEditingAlert$ | async) &&
            !(isCreatingAlert$ | async)
          "
          class="edit-button-container">
          <lib-button-outlined (buttonClicked)="toggleIsEditingAlert()">
            <img [src]="'assets/icons/primary/EditIcon.svg'" />
            <span i18n>Edit Alert</span>
          </lib-button-outlined>
        </div>
      </div>

      <div [formGroup]="form">
        <!-- Alert Appearance-->
        <app-base-card [height]="'100%'" class="alert-details-card">
          <div class="card-header">
            <span i18n>Appearance</span>
          </div>
          <div class="card-subtitle mt-1 mb-4" i18n *ngIf="(isCreatingAlert$ | async) || (isEditingAlert$ | async)">
            Choose <span class="card-highlight">Card</span> for more detailed messages and a button with a custom
            destination. If your message is more succinct, choose <span class="card-highlight">Banner</span>.
          </div>
          <div class="radio-row">
            <div class="radio-title" i18n>Message Style</div>
            <div class="radio-container">
              <label class="radio-option" [class.disabled]="!(formEditable$ | async)">
                <app-radio-button-input
                  formControlName="typeId"
                  name="typeId"
                  controlId="alert-type-card"
                  [value]="AlertTypeEnum.Card" />
                <span class="radio-label" i18n>Card</span>
              </label>
              <label class="radio-option" [class.disabled]="!(formEditable$ | async)">
                <app-radio-button-input
                  formControlName="typeId"
                  name="typeId"
                  controlId="alert-type-banner"
                  [value]="AlertTypeEnum.Banner" />
                <span class="radio-label" i18n>Banner</span>
              </label>
            </div>
          </div>
          <hr class="radio-divider" />
          <div class="radio-row">
            <div class="radio-title" i18n>Colour Scheme</div>
            <div class="d-flex flex-column gap-2">
              <div class="radio-container">
                <label
                  class="radio-option"
                  *ngFor="let b of cardRadioButtons$ | async; trackBy: trackByRadioValue"
                  [hidden]="!(isCardTypeAlert$ | async)"
                  [class.disabled]="!(formEditable$ | async)">
                  <app-radio-button-input
                    formControlName="colourId"
                    name="colourId"
                    [controlId]="'colour-card-' + b.value"
                    [value]="b.value" />
                  <span class="radio-label">{{ b.name }}</span>
                </label>
                <label
                  class="radio-option"
                  *ngFor="let b of bannerRadioButtons$ | async; trackBy: trackByRadioValue"
                  [hidden]="isCardTypeAlert$ | async"
                  [class.disabled]="!(formEditable$ | async)">
                  <app-radio-button-input
                    formControlName="colourId"
                    name="colourId"
                    [controlId]="'colour-banner-' + b.value"
                    [value]="b.value" />
                  <span class="radio-label">{{ b.name }}</span>
                </label>
              </div>
              <app-form-error
                *ngIf="(formSubmitAttempted$ | async) && form.controls.colourId.invalid"
                [errors]="form.controls.colourId.errors" />
            </div>
          </div>
          <hr class="radio-divider mb-0" />
          <div [style.display]="(isCardTypeAlert$ | async) ? 'none' : 'flex'" [style.height.rem]="3">
            <div class="radio-title dismissal" i18n>Allow Dismissal</div>
            <div class="radio-container mt-4" [hidden]="isCardTypeAlert$ | async">
              <app-toggle-switch-input
                formControlName="dismissable"
                controlId="dismissable"
                ariaLabel="Allow Dismissal"
                i18n-ariaLabel />
              <hr class="divider" />
            </div>
          </div>
          <div [style.display]="(isCardTypeAlert$ | async) ? 'flex' : 'none'" [style.height.rem]="3">
            <div class="radio-title dismissal" i18n>Include Button</div>
            <div class="radio-container mt-4" [hidden]="!(isCardTypeAlert$ | async)">
              <app-toggle-switch-input
                formControlName="includeButton"
                controlId="includeButton"
                ariaLabel="Include Button"
                i18n-ariaLabel />
              <hr class="divider" />
            </div>
          </div>
        </app-base-card>
        <!-- Content -->
        <app-base-card class="alert-details-card">
          <span class="card-header mb-4" i18n>Message Content</span>
          <div class="d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-1">
              <label
                for="title"
                [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                i18n>
                Title
              </label>
              <app-text-input
                *ngIf="isCreatingAlert$ | async; else titleReview"
                formControlName="title"
                controlId="title"
                [maxLength]="maxAlertTitleLength"
                [error]="(formSubmitAttempted$ | async) && form.controls.title.invalid" />
              <ng-template #titleReview>
                <app-review-text-input
                  formControlName="title"
                  controlId="title"
                  [maxLength]="maxAlertTitleLength"
                  [error]="(formSubmitAttempted$ | async) && form.controls.title.invalid" />
              </ng-template>
              <app-form-error
                *ngIf="(formSubmitAttempted$ | async) && form.controls.title.invalid"
                [errors]="form.controls.title.errors" />
            </div>
            <div class="d-flex flex-column gap-1">
              <label
                for="description"
                [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                i18n>
                Description
              </label>
              <app-textarea-input
                *ngIf="isCreatingAlert$ | async; else descriptionReview"
                formControlName="description"
                controlId="description"
                [maxLength]="maxAlertDescriptionLength"
                [error]="(formSubmitAttempted$ | async) && form.controls.description.invalid" />
              <ng-template #descriptionReview>
                <app-review-textarea-input
                  formControlName="description"
                  controlId="description"
                  [maxLength]="maxAlertDescriptionLength"
                  [error]="(formSubmitAttempted$ | async) && form.controls.description.invalid" />
              </ng-template>
              <app-form-error
                *ngIf="(formSubmitAttempted$ | async) && form.controls.description.invalid"
                [errors]="form.controls.description.errors" />
            </div>
            <div [hidden]="!(isCardTypeAlert$ | async) || !(includeButton$ | async)" class="d-flex flex-column gap-4">
              <div class="d-flex flex-column gap-1">
                <label
                  for="buttonText"
                  [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                  i18n>
                  Button Text
                </label>
                <app-text-input
                  *ngIf="isCreatingAlert$ | async; else buttonTextReview"
                  formControlName="buttonText"
                  controlId="buttonText"
                  [maxLength]="maxAlertButtonLength"
                  [error]="(formSubmitAttempted$ | async) && form.controls.buttonText.invalid" />
                <ng-template #buttonTextReview>
                  <app-review-text-input
                    formControlName="buttonText"
                    controlId="buttonText"
                    [maxLength]="maxAlertButtonLength"
                    [error]="(formSubmitAttempted$ | async) && form.controls.buttonText.invalid" />
                </ng-template>
                <app-form-error
                  *ngIf="(formSubmitAttempted$ | async) && form.controls.buttonText.invalid"
                  [errors]="form.controls.buttonText.errors" />
              </div>
              <div class="d-flex flex-column gap-1">
                <label
                  for="buttonLink"
                  [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                  i18n>
                  Button Link
                </label>
                <app-text-input
                  *ngIf="isCreatingAlert$ | async; else buttonLinkReview"
                  formControlName="buttonLink"
                  controlId="buttonLink"
                  placeholder="https://"
                  i18n-placeholder
                  [error]="(formSubmitAttempted$ | async) && form.controls.buttonLink.invalid" />
                <ng-template #buttonLinkReview>
                  <app-review-text-input
                    formControlName="buttonLink"
                    controlId="buttonLink"
                    placeholder="https://"
                    i18n-placeholder
                    [error]="(formSubmitAttempted$ | async) && form.controls.buttonLink.invalid" />
                </ng-template>
                <span class="hint-text" i18n>Button links will automatically open in a new browser tab</span>
                <app-form-error
                  *ngIf="(formSubmitAttempted$ | async) && form.controls.buttonLink.invalid"
                  [errors]="form.controls.buttonLink.errors" />
              </div>
            </div>
          </div>
        </app-base-card>
        <!-- Duration -->
        <app-base-card class="alert-details-card">
          <span class="card-header mb-4" i18n>Alert Duration</span>
          <div class="d-flex flex-column gap-4">
            <div class="d-flex duration-row">
              <div class="d-flex flex-column gap-1 w-50">
                <label
                  for="startDate"
                  [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                  i18n>
                  Start Date
                </label>
                <app-datepicker-input
                  *ngIf="isCreatingAlert$ | async; else startDateReview"
                  formControlName="startDateString"
                  controlId="startDate"
                  placeholder="Select"
                  i18n-placeholder
                  [error]="(formSubmitAttempted$ | async) && form.controls.startDateString.invalid" />
                <ng-template #startDateReview>
                  <app-review-datepicker-input
                    formControlName="startDateString"
                    controlId="startDate"
                    placeholder="Select"
                    i18n-placeholder
                    [error]="(formSubmitAttempted$ | async) && form.controls.startDateString.invalid" />
                </ng-template>
                <span class="hint-text" i18n>DD / MM / YYYY</span>
                <app-form-error
                  *ngIf="(formSubmitAttempted$ | async) && form.controls.startDateString.invalid"
                  [customErrorMessages]="customErrorMessages.date"
                  [errors]="form.controls.startDateString.errors" />
              </div>
              <div class="d-flex flex-column gap-1 w-50">
                <label
                  for="startTime"
                  [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                  i18n>
                  Start Time
                </label>
                <div class="d-flex gap-2 time-row" *ngIf="isCreatingAlert$ | async; else startTimeReview">
                  <app-dropdown-input
                    class="meridiem-dropdown"
                    controlId="startMeridiem"
                    [formControl]="startMeridiemControl"
                    [dropdowns]="meridiemOptions" />
                  <app-masked-text-input
                    class="time-input"
                    controlId="startTime"
                    placeholder="HH:MM"
                    i18n-placeholder
                    [formControl]="startTime12hControl"
                    [maskOptions]="timeMaskOptions"
                    [error]="(formSubmitAttempted$ | async) && form.controls.startTime.invalid" />
                </div>
                <ng-template #startTimeReview>
                  <div class="d-flex gap-2 time-row">
                    <app-review-dropdown-input
                      class="meridiem-dropdown"
                      controlId="startMeridiem"
                      [formControl]="startMeridiemControl"
                      [dropdowns]="meridiemOptions" />
                    <app-review-text-input
                      class="time-input"
                      controlId="startTime"
                      placeholder="HH:MM"
                      i18n-placeholder
                      [formControl]="startTime12hControl"
                      [maskOptions]="timeMaskOptions"
                      [error]="(formSubmitAttempted$ | async) && form.controls.startTime.invalid" />
                  </div>
                </ng-template>
                <span class="hint-text" i18n>Time in CST</span>
                <app-form-error
                  *ngIf="(formSubmitAttempted$ | async) && form.controls.startTime.invalid"
                  [errors]="form.controls.startTime.errors" />
              </div>
            </div>
            <div class="d-flex duration-row">
              <div class="d-flex flex-column gap-1 w-50">
                <label
                  for="endDate"
                  [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                  i18n>
                  End Date
                </label>
                <app-datepicker-input
                  *ngIf="isCreatingAlert$ | async; else endDateReview"
                  formControlName="endDateString"
                  controlId="endDate"
                  placeholder="Select"
                  i18n-placeholder
                  [error]="
                    (formSubmitAttempted$ | async) &&
                    (form.controls.endDateString.invalid || !!form.errors?.validStartEndDate)
                  " />
                <ng-template #endDateReview>
                  <app-review-datepicker-input
                    formControlName="endDateString"
                    controlId="endDate"
                    placeholder="Select"
                    i18n-placeholder
                    [error]="
                      (formSubmitAttempted$ | async) &&
                      (form.controls.endDateString.invalid || !!form.errors?.validStartEndDate)
                    " />
                </ng-template>
                <span class="hint-text" i18n>DD / MM / YYYY</span>
                <app-form-error
                  *ngIf="(formSubmitAttempted$ | async) && form.controls.endDateString.invalid"
                  [customErrorMessages]="customErrorMessages.date"
                  [errors]="form.controls.endDateString.errors" />
                <app-form-error
                  *ngIf="
                    (formSubmitAttempted$ | async) &&
                    !form.controls.endDateString.invalid &&
                    !!form.errors?.validStartEndDate
                  "
                  [customErrorMessages]="customErrorMessages.startEndDate"
                  [errors]="form.errors" />
              </div>
              <div class="d-flex flex-column gap-1 w-50">
                <label
                  for="endTime"
                  [ngClass]="(isCreatingAlert$ | async) ? 'form-input-label' : 'review-input-label'"
                  i18n>
                  End Time
                </label>
                <div class="d-flex gap-2 time-row" *ngIf="isCreatingAlert$ | async; else endTimeReview">
                  <app-dropdown-input
                    class="meridiem-dropdown"
                    controlId="endMeridiem"
                    [formControl]="endMeridiemControl"
                    [dropdowns]="meridiemOptions" />
                  <app-masked-text-input
                    class="time-input"
                    controlId="endTime"
                    placeholder="HH:MM"
                    i18n-placeholder
                    [formControl]="endTime12hControl"
                    [maskOptions]="timeMaskOptions"
                    [error]="
                      (formSubmitAttempted$ | async) &&
                      (form.controls.endTime.invalid || !!form.errors?.validStartEndDate)
                    " />
                </div>
                <ng-template #endTimeReview>
                  <div class="d-flex gap-2 time-row">
                    <app-review-dropdown-input
                      class="meridiem-dropdown"
                      controlId="endMeridiem"
                      [formControl]="endMeridiemControl"
                      [dropdowns]="meridiemOptions" />
                    <app-review-text-input
                      class="time-input"
                      controlId="endTime"
                      placeholder="HH:MM"
                      i18n-placeholder
                      [formControl]="endTime12hControl"
                      [maskOptions]="timeMaskOptions"
                      [error]="
                        (formSubmitAttempted$ | async) &&
                        (form.controls.endTime.invalid || !!form.errors?.validStartEndDate)
                      " />
                  </div>
                </ng-template>
                <span class="hint-text" i18n>Time in CST</span>
                <app-form-error
                  *ngIf="(formSubmitAttempted$ | async) && form.controls.endTime.invalid"
                  [errors]="form.controls.endTime.errors" />
              </div>
            </div>
          </div>
        </app-base-card>
        <!-- Targeting -->
        <app-base-card>
          <span class="card-header mb-4" i18n>Targeting Parameters</span>
          <div class="radio-row">
            <div class="radio-title" i18n>Audience</div>
            <div class="d-flex flex-column gap-2">
              <div class="radio-container">
                <label
                  class="radio-option"
                  *ngFor="let b of portalTypeRadioButtons; trackBy: trackByRadioValue"
                  [class.disabled]="!(formEditable$ | async)">
                  <app-radio-button-input
                    formControlName="portalTypeId"
                    name="portalTypeId"
                    [controlId]="'portal-' + b.value"
                    [value]="b.value" />
                  <span class="radio-label">{{ b.name }}</span>
                </label>
              </div>
              <app-form-error
                *ngIf="(formSubmitAttempted$ | async) && form.controls.portalTypeId.invalid"
                [errors]="form.controls.portalTypeId.errors" />
            </div>
          </div>
        </app-base-card>
      </div>
    </div>
    <div class="card-form-action-container">
      <app-base-card
        *ngIf="!(isCreatingAlert$ | async)"
        [width]="'100%'"
        class="d-flex"
        [style.margin-top]="(isPastAlert$ | async) ? '2.15rem' : '5.375rem'">
        <div class="d-flex flex-column" [style.gap.rem]="1">
          <div class="overview-title-container">
            <div class="card-title" [style.margin-bottom.rem]="0" i18n>Alert Overview</div>
          </div>
          <div class="d-flex flex-column gap-4">
            <app-submission-details-list-item label="Status" i18n-label [statusPill]="statusPill$ | async" />
            <app-submission-details-list-item
              label="Alert Start Date"
              i18n-label
              [text]="(alertStartDate$ | async) ?? '-'" />
            <app-submission-details-list-item
              label="Alert End Date"
              i18n-label
              [text]="(alertEndDate$ | async) ?? '-'" />
            <app-submission-details-list-item
              label="Last Edited"
              i18n-label
              [text]="(alertLastUpdatedDate$ | async) ?? '-'" />
          </div>
        </div>
      </app-base-card>
      <app-base-card
        [height]="'100%'"
        [padding]="'1.5rem'"
        class="d-flex"
        [style.margin-top]="(isCreatingAlert$ | async) ? '2.15rem' : '0'">
        <div class="d-flex flex-column gap-3">
          <div class="preview-title">
            <span class="preview" i18n>Preview</span>
            <app-toggle-switch-input
              controlId="showPreview"
              ariaLabel="Show alert preview"
              i18n-ariaLabel
              [formControl]="showPreviewControl" />
          </div>
          <div class="preview-subtext" i18n>View how desktop SPP Portal users will see your alert.</div>
        </div>
      </app-base-card>
      <app-card-alert
        *ngIf="(showCardAlertPreview$ | async) && !(previewLoading$ | async)"
        [alert]="alertPreview$ | async" />
      <lib-loading-shimmer
        *ngIf="(showCardAlertPreview$ | async) && (previewLoading$ | async)"
        [width]="'100%'"
        [height]="'14.875rem'" />
    </div>
  </div>
</div>
<div class="action-button-container">
  <div
    class="action-buttons"
    *ngIf="((canEditAlertDetails$ | async) && (isEditingAlert$ | async)) || (isCreatingAlert$ | async)">
    <app-secondary-button [size]="BaseButtonSizeEnum.sm" i18n (buttonClicked)="cancelClicked()">
      Cancel
    </app-secondary-button>
    <app-primary-button [size]="BaseButtonSizeEnum.sm" (buttonClicked)="onSubmit()">{{
      actionButtonText$ | async
    }}</app-primary-button>
  </div>
</div>
